import React from 'react';
import { Tooltip, Icon } from 'antd';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import { getPathHeader } from '../../../../../utils/utils';
import { getAppCode } from '../../utils/utils';

const columns = ({ startMonth, endMonth, activeKey, isPerson }) => [
  {
    title: '分组',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: (
      <div>
        有效发布文章数&nbsp;
        <Tooltip title="由本组织发布成功，且未删除的文章为有效文章">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'articleSum',
    key: 'articleSum',
    width: 250,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 150,
    render: (text, record) => {
      const { nodeId = '', detail } = record || {};
      const typeValue =
        // 1为学校/2为教育局
        // eslint-disable-next-line no-nested-ternary
        activeKey === 'key2' && detail === 1 ? 'editor' : 'detail';
      const params = `appCode=${getAppCode()}&nodeId=${nodeId}&type=${typeValue}&activeKey=${activeKey}&startMonth=${startMonth}&endMonth=${endMonth}&isPerson=${isPerson}`;
      const url = `/${getPathHeader()}/manuscriptCount/releasedstatistics/detail/${typeValue}?${params}`;
      return <a onClick={() => router.push(url)}>详情</a>;
    },
  },
];

const detailColumns = ({ startMonth, endMonth, activeKey, isPerson }) => [
  {
    title: '分组',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: '所在省',
    dataIndex: 'region',
    key: 'region',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '所在市',
    dataIndex: 'city',
    key: 'city',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '所在区',
    dataIndex: 'area',
    key: 'area',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '学校性质',
    dataIndex: 'orgProperty',
    key: 'orgProperty',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '学段',
    dataIndex: 'orgType',
    key: 'orgType',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '组织类型',
    dataIndex: 'managementEntitySign',
    key: 'managementEntitySign',
    render: text => {
      return text || '-';
    },
  },
  {
    title: (
      <div>
        有效发布文章数&nbsp;
        <Tooltip title="由本组织发布成功，且未删除的文章为有效文章">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'articleSum',
    key: 'articleSum',
  },
  {
    title: '操作',
    dataIndex: 'index',
    key: 'index',
    width: 150,
    render: (text, record) => {
      const { nodeId = '', type = '', detail } = record || {};
      const typeValue =
        // 1为学校/2为教育局
        // eslint-disable-next-line no-nested-ternary
        type === '2' ? 'coutry' : detail === 1 ? 'editor' : 'detail';
      const params = `appCode=${getAppCode()}&nodeId=${nodeId}&type=${typeValue}&activeKey=${activeKey}&startMonth=${startMonth}&endMonth=${endMonth}&isPerson=${isPerson}`;
      const url = `/${getPathHeader()}/manuscriptCount/releasedstatistics/detail/${typeValue}?${params}`;
      return <a onClick={() => router.push(url)}>详情</a>;
    },
  },
];

const editorColums = [
  {
    title: '分组',
    dataIndex: 'nodeName',
    key: 'nodeName',
  },
  {
    title: '通讯员',
    dataIndex: 'publishUserName',
    key: 'publishUserName',
  },
  {
    title: '所在省',
    dataIndex: 'region',
    key: 'region',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '所在市',
    dataIndex: 'city',
    key: 'city',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '所在区',
    dataIndex: 'area',
    key: 'area',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '学校性质',
    dataIndex: 'orgProperty',
    key: 'orgProperty',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '学段',
    dataIndex: 'orgType',
    key: 'orgType',
    render: text => {
      return text || '-';
    },
  },
  {
    title: '组织类型',
    dataIndex: 'managementEntitySign',
    key: 'managementEntitySign',
    render: text => {
      return text || '-';
    },
  },
  {
    title: (
      <div>
        有效发布文章数&nbsp;
        <Tooltip title="由本组织发布成功，且未删除的文章为有效文章">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: 'articleSum',
    key: 'articleSum',
  },
];

export { columns, detailColumns, editorColums };
